import $ from 'jquery'
import {
  calculateExtraPackageTotal,
  calculateExtraTotal,
  calculatePackageTotal,
  calculateMealTotal,
  calculateAllFee,
} from './price-function'

function getUrlParameter(name) {
  const params = new URLSearchParams(window.location.search)
  return params.get(name)
}
$(document).ready(function () {
  const $peopleCountInput = $('#number-of-people')
  const $peopleCountMinusButton = $('.people-minus')
  const $peopleCountPlusButton = $('.people-plus')

  const capacity = parseInt($peopleCountInput.data('capacity'))
  const minValue = 1
  const maxValue = capacity

  const kisiParam = getUrlParameter('kisi')
  let initialValue = parseInt(kisiParam)

  if (isNaN(initialValue)) {
    initialValue = parseInt($peopleCountInput.val())
  } else {
    initialValue = Math.min(Math.max(initialValue, minValue), maxValue)
    $peopleCountInput.val(initialValue)
  }

  $peopleCountMinusButton.toggleClass('disabled', initialValue <= minValue)
  $peopleCountPlusButton.toggleClass('disabled', initialValue >= maxValue)

  $peopleCountPlusButton.on('click', function (event) {
    event.preventDefault()
    let currentValue = parseInt($peopleCountInput.val())
    if (currentValue < maxValue) {
      $peopleCountInput.val(currentValue + 1)
    }
    if (currentValue === minValue) {
      $peopleCountMinusButton.removeClass('disabled')
    }
    if (currentValue === maxValue - 1) {
      $peopleCountPlusButton.addClass('disabled')
    }
    calculateMealTotal()
    calculatePackageTotal()
    calculateExtraTotal()
    calculateExtraPackageTotal()
    calculateAllFee()
  })

  $peopleCountMinusButton.on('click', function (event) {
    event.preventDefault()
    let currentValue = parseInt($peopleCountInput.val())
    if (currentValue > minValue) {
      $peopleCountInput.val(currentValue - 1)
    }
    if (currentValue === 2) {
      $peopleCountMinusButton.addClass('disabled')
    }
    if (currentValue === maxValue) {
      $peopleCountPlusButton.removeClass('disabled')
    }
    calculateMealTotal()
    calculatePackageTotal()
    calculateExtraTotal()
    calculateExtraPackageTotal()
    calculateAllFee()
  })

  $('#number-of-people').on('input', function () {
    let currentValue = parseInt($peopleCountInput.val())

    if (currentValue > maxValue) {
      $peopleCountInput.val(maxValue)
      $peopleCountPlusButton.addClass('disabled')
      $peopleCountMinusButton.removeClass('disabled')
    } else if (currentValue < minValue) {
      $peopleCountInput.val(minValue)
      $peopleCountPlusButton.removeClass('disabled')
      $peopleCountMinusButton.addClass('disabled')
    } else {
      $peopleCountPlusButton.removeClass('disabled')
      $peopleCountMinusButton.removeClass('disabled')
    }

    if ($(this).val() === '') {
      $(this).val(1)
      $peopleCountMinusButton.addClass('disabled')
    }

    calculateMealTotal()
    calculatePackageTotal()
    calculateExtraTotal()
    calculateExtraPackageTotal()
    calculateAllFee()
  })

  const checkbox_meals = document.getElementsByName('meal-selection')

  checkbox_meals.forEach((checkbox_meal) => {
    checkbox_meal.addEventListener('change', function () {
      const meal_fee_info = $('.get-offer__meal-fee-preview')

      if ($('.single-menu__meal-checkbox:checked').length === 0) {
        meal_fee_info.addClass('disabled')
      } else {
        meal_fee_info.removeClass('disabled')
      }
      calculateMealTotal()
      calculateAllFee()
    })
  })

  const checkbox_packages = document.getElementsByName('package-selection')

  checkbox_packages.forEach((checkbox_package) => {
    checkbox_package.addEventListener('change', function () {
      const extra_fee_info = $('.get-offer__extra-fee-preview')

      if (
        $('.single-menu__packages-checkbox:checked').length === 0 &&
        $('.single-menu__extras-checkbox:checked').length === 0
      ) {
        extra_fee_info.addClass('disabled')
      } else {
        extra_fee_info.removeClass('disabled')
      }
      calculatePackageTotal()
      calculateExtraPackageTotal()
      calculateAllFee()
    })
  })

  const checkbox_extras = document.getElementsByName('extra-selection')

  checkbox_extras.forEach((checkbox_extra) => {
    checkbox_extra.addEventListener('change', function () {
      const extra_fee_info = $('.get-offer__extra-fee-preview')

      if (
        $('.single-menu__packages-checkbox:checked').length === 0 &&
        $('.single-menu__extras-checkbox:checked').length === 0
      ) {
        extra_fee_info.addClass('disabled')
      } else {
        extra_fee_info.removeClass('disabled')
      }
      calculateExtraTotal()
      calculateExtraPackageTotal()
      calculateAllFee()
    })
  })
})
